/*eslint-disable*/
import {
    queryAddressPlace
} from '@/modules/mdm/api/customer/customerManage.js';
import { urlReg, idNumber, phoneReg, email, ebcuZipCOde, telephoneReg } from '@/modules/mdm/utils/regList.js'
export const addedDictKeys = 'EBCU_CUSTOMER_TYPE_OVERSEAS,EBCU_CUSTOMER_TYPE'

const optionsFormat = (item, isLeaf) => {
    return {
        label: item.nameCn || item.nameLo,
        nameLo: item.nameLo || '',
        nameEn: item.nameEn || '',
        value: item.code,
        leaf: isLeaf,
    }
}
const accountEntityEnabled = 1 // 会计主体启用状态
export const desensitization = {
    // 身份证号码脱敏：保留前6位和后4位
    idCard: (idCard) => {
        if (!idCard) return idCard;

        // 处理15位身份证
        if (idCard.length === 15) {
            return idCard.substring(0, 6) + '******' + idCard.substring(12);
        }

        // 处理18位身份证
        if (idCard.length === 18) {
            return idCard.substring(0, 6) + '********' + idCard.substring(14);
        }

        // 其他情况
        if (idCard.length > 10) {
            const visibleStart = Math.min(6, Math.floor(idCard.length / 3));
            const visibleEnd = Math.min(4, Math.floor(idCard.length / 4));
            const hiddenLength = idCard.length - visibleStart - visibleEnd;
            return idCard.substring(0, visibleStart) + '*'.repeat(hiddenLength) + idCard.substring(idCard.length - visibleEnd);
        }

        return idCard;
    }
}

// 表单配置信息
export const collapse = [
    {
        title: '管理信息',
        ref: 'manageForm',
        formName: 'manageInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '客户编码',
                prop: 'customerCode',
                value: 'customerCode',
                type: 'custom',
                opsUnlockType: 'input'
            },
            {
                label: '客户名称',
                prop: 'customerName',
                value: 'customerName',
                type: 'custom',
                maxlength: 200,
                rule: [
                    { required: true, message: '客户名称不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input'
            },
            {
                label: '客户简称',
                prop: 'customerShortName',
                value: 'customerShortName',
                type: 'custom',
                rule: [
                    // 非虚拟客户必填
                    { required: true, message: '客户简称不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input'
            },
            {
                label: '英文名称',
                prop: 'ebcuNameEn',
                value: 'ebcuNameEn',
                type: 'input',
                rule: [
                    { required: false, message: '英文不能为空', trigger: 'change' },
                    // {
                    //     pattern: noChineseReg,
                    //     message: '英文格式不对',
                    //     trigger: 'blur'
                    // }
                ],
                opsUnlockType: 'input'
            },
            {
                label: '主客户编码',
                prop: 'belongCustomerCode',
                value: 'belongCustomerCode',
                type: 'custom',
                opsUnlockType: 'input'
            },

            {
                label: '客户系',
                prop: 'customerGroupName',
                value: 'customerGroupName',
                name: '客户系',
                type: 'advance',
                advanceConfig: [
                    { prop: 'customerGroupName', value: '客户系名称' },
                    { prop: 'customerGroupCode', value: '客户系编码' }
                ],
                tableConfig: [
                    { prop: 'customerGroupCode', value: '客户系编码' },
                    { prop: 'customerGroupName', value: '客户系名称' }
                ],
                prefix: '/api-lcrm',
                advanceUrl: '/customer/group/info/page',
                cbParams: ['customerGroupCode', 'customerGroupName', 'calCustomerLevelCode#calCustomerLevelCode'],
                width: 150,
                visible: true,
                rule: [
                    { required: true, message: '客户系不能为空', trigger: 'change' }
                ],
                beforeRequest: (params) => {
                    return params;
                },
                opsUnlockType: 'advance'
            },
            {
                label: '细分等级',
                prop: 'calCustomerLevelCode',
                value: 'calCustomerLevelCode',
                type: 'custom',
                optionsKey: 'NEOCRM_CUSTOMER_LEVEL',
                opsUnlockType: 'select'
            },
            {
                label: '企业集团',
                prop: 'groupRename',
                value: 'groupRename',
                type: 'custom',
            },
            {
                label: '企业集团取值来源',
                prop: 'groupRenameSource',
                value: 'groupRenameSource',
                type: 'custom',
                optionsKey: 'GROUP_RENAME_SOURCE',
                opsUnlockType: 'select'
            },
            // {
            //     label: '行业大类',
            //     prop: 'industryCategoriesName',
            //     value: 'industryCategoriesName',
            //     type: 'custom',
            // },
            // {
            //     label: '细分行业',
            //     prop: 'lmsIndustryTypeName',
            //     value: 'industryType',
            //     name: '请选择客户系',
            //     type: 'advanceMulti',
            //     advanceConfig: [
            //         { 'prop': 'industryTypeName', 'value': '细分行业' }
            //     ],
            //     tableConfig: [
            //         { 'prop': 'industryCategoriesName', 'value': '行业大类' },
            //         { 'prop': 'industryCategoriesCode', 'value': '行业大类编码' },
            //         { 'prop': 'industryTypeName', 'value': '细分行业' },
            //         { 'prop': 'industryTypeCode', 'value': '细分行业编码' }
            //     ],
            //     method: 'post',
            //     prefix: '/api-lcrm',
            //     advanceUrl: `/industry/info/page`,
            //     cbParams: ['industryTypeName', 'industryTypeCode', 'industryCategoriesName#industryCategories', 'industryCategoriesCode'],
            //     advanceCascade: 'lmsIndustryBigTypeCode',
            //     width: 150,
            //     visible: true,
            //     rule: [
            //         { required: true, message: '客户系不能为空', trigger: 'change' }
            //     ]
            // },
            {
                label: '行业大类',
                prop: 'industryCategoriesName',
                value: 'industryCategoriesName',
                type: 'custom'
            },
            {
                label: '细分行业',
                prop: 'industryType',
                value: 'industryType',
                type: 'custom',
                props: {
                    multiple: false,
                    value: 'industryCode',
                    label: 'industryName'
                },
                changeOnSelect: true,
                options: [],
                rule: [
                    { required: false, message: '细分行业不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'custom',
            },
            // {
            //     label: '细分行业',
            //     prop: 'industryType',
            //     value: 'industryType',
            //     type: 'select',
            //     optionsKey: 'SYS_INDUSTRY_TYPE',
            //     rule: [
            //         { required: true, message: '细分行业不能为空', trigger: 'change' }
            //     ]

            // },
            {
                label: '风险等级',
                prop: 'riskLevel',
                value: 'riskLevel',
                multiple: true,
                type: 'custom',
                optionsKey: 'LMDM_RISKLEVEL',
                opsUnlockType: 'select',

            },
            {
                label: '客户分类',
                prop: 'ebcuCustomerType',
                value: 'ebcuCustomerType',
                type: 'select',
                optionsKey: 'EBCU_CUSTOMER_TYPE',
                rule: [
                    { required: true, message: '客户分类不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '双算标识',
                prop: 'bizRevId',
                value: 'bizRevId',
                type: 'custom',
                optionsKey: 'BIZ_REV_ID_TYPE',
                opsUnlockType: 'select',
            },
            {
                label: '战略合作类型',
                prop: 'teamType',
                value: 'teamType',
                type: 'custom',
                // type: 'select',
                optionsKey: 'CUSTOMER_TEAM_TYPE',
                opsUnlockType: 'select',
            },
            {
                label: '内外渠',
                prop: 'customerChannel',
                value: 'customerChannel',
                optionsKey: 'LMDM_CUSTOMER_CHANNEL',
                type: 'custom',
                rule: [
                    { required: true, message: '内外渠不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '集团编码',
                prop: 'originalGroupCode',
                value: 'originalGroupCode',
                type: 'custom',
                opsUnlockType: 'input',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                value: 'supplierCode',
                name: '供应商编码',
                // type: 'advance',
                type: 'advance',
                advanceConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierName', value: '供应商名称' },
                ],
                tableConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' }
                ],
                method: 'post',
                prefix: '/api-lcrm',
                advanceUrl: '/customer/info/querySupplier',
                cbParams: ['supplierCode', 'supplierNameCn#supplierName'],
                advanceCode: 'advanceCode',
                width: 150,
                visible: true,
                rule: [
                    { required: false, message: '供应商编码不能为空', trigger: 'change' }
                ],
                isOpenFetchFunc: () => {

                },
                beforeRequest: (params) => {
                    params.data = {}
                    if (params.supplierCode) {
                        params.data.supplierCodeList = [params.supplierCode]
                    }
                    if (params.supplierName) {
                        params.data.supplierName = params.supplierName
                    }
                    delete params.supplierName
                    delete params.supplierCode
                    return params;
                },
                opsUnlockType: 'advance',
            },
            {
                label: '所属事业部',
                prop: 'ebcuBuCode',
                value: 'ebcuBuCode',
                type: 'select',
                optionsKey: 'SYS_BUSINESS_UNIT',
                rule: [
                    { required: true, message: '所属事业部不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '美的渠道角色',
                prop: 'customerChannelRole',
                value: 'customerChannelRole',
                type: 'custom',
                optionsKey: 'LMDM_CUSTOMER_CHANNEL_ROLE',
                rule: [
                    { required: false, message: '美的渠道角色不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '内外销客户',
                prop: 'isImpExpCustomer',
                value: 'isImpExpCustomer',
                optionsKey: 'IS_IMP_EXP_CUSTOMER',
                type: 'custom',
                rule: [
                    { required: true, message: '内外销客户不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '客户经理/开发人',
                prop: 'customerOwnerName',
                value: 'customerOwnerName',
                name: '客户经理/开发人',
                rule: [
                    { required: true, message: '客户经理/开发人不能为空', trigger: 'change' }
                ],
                type: 'advance',

                advanceConfig: [
                    { 'prop': 'esusUserNameCn', 'value': '姓名' },
                    { 'prop': 'esusLoginName', 'value': '美信号' },
                ],
                tableConfig: [
                    { 'prop': 'esusId', 'value': 'ID' },
                    { 'prop': 'esusLoginName', 'value': '美信号' },
                    { 'prop': 'esusUserNameCn', 'value': '姓名' },
                    { 'prop': 'esusPositionName', 'value': '职位' },
                    { 'prop': 'escoCompanyNameCn', 'value': '部门' }
                ],
                prefix: '/api-mdm',
                advanceUrl: `/selectUserCompany`,
                cbParams: ['esusUserNameCn#customerOwnerName', 'esusLoginName#customerOwnerCode'],
                opsUnlockType: 'advance',
            },
            {
                label: '是否白名单',
                prop: 'isWhitelist',
                value: 'isWhitelist',
                optionsKey: 'SYS_YES_NO',
                type: 'custom',
                rule: [
                    { required: false, message: '是否白名单不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '备注',
                prop: 'ebcuRemark',
                value: 'ebcuRemark',
                type: 'custom',
                sourceType: 'input',
                inputType: 'textarea',
                rows: 3,
                visible: true,
                span: 18,
                rule: [
                    { required: false, message: '备注不能为空', trigger: 'change' }
                ]
            },

        ]
    },
    {
        title: '注册信息',
        ref: 'registerForm',
        formName: 'registerInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '客户控制类型',
                prop: 'customerBodyType',
                value: 'customerBodyType',
                type: 'custom',
                optionsKey: 'SYS_RELATION_LEVEL',
                rule: [
                    { required: false, message: '客户控制类型不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '社会信用代码',
                prop: 'societyCreditCode',
                value: 'societyCreditCode',
                type: 'custom',
                visible: false,
                rule: [
                    { required: false, message: '社会信用代码不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '营业执照号/注册号',
                prop: 'ebcuBusinessNo',
                type: 'custom',
                visible: false,
                rule: [
                    { required: false, message: '营业执照号/注册号不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '组织机构代码',
                prop: 'ebcuOrgBarcode',
                value: 'ebcuOrgBarcode',
                type: 'input',
                visible: false,
                width: 140,
                rule: [
                    { required: false, message: '组织机构代码不能为空', trigger: ['change', 'blur'] }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '纳税号',
                prop: 'ebcuTaxRegistNo',
                value: 'ebcuTaxRegistNo',
                type: 'custom',
                visible: false,
                rule: [
                    { required: false, message: '纳税号不能为空', trigger: ['change'] }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '法人代表',
                prop: 'ebcuLegalEntity',
                value: 'ebcuLegalEntity',
                type: 'custom',
                visible: false,
                rule: [
                    { required: false, message: '法人代表不能为空', trigger: ['change'] }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '中信保编码',
                prop: 'sinosureCode',
                value: 'sinosureCode',
                type: 'custom',
                visible: false,
                rule: [
                    { required: false, message: '中信保编码不能为空', trigger: ['change'] }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '身份证',
                prop: 'idNumber',
                value: 'idNumber',
                type: 'custom',
                rule: [
                    { required: false, message: '身份证不能为空', trigger: ['change'] },
                    {
                        pattern: idNumber,
                        message: '身份证格式不对',
                        trigger: 'blur'
                    }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '纳税登记人',
                prop: 'ebcuTaxpayers',
                value: 'ebcuTaxpayers',
                type: 'input',
                width: 140,
                rule: [
                    { required: false, message: '纳税登记人不能为空', trigger: ['change', 'blur'] }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '纳税人类型',
                prop: 'ebcuTaxpayersType',
                value: 'ebcuTaxpayersType',
                type: 'custom',
                optionsKey: 'SYS_TAXER_TYPE',
                rule: [
                    { required: false, message: '纳税人类型不能为空', trigger: ['change'] }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '注册金额',
                prop: 'ebcuRegisteredCapital',
                value: 'ebcuRegisteredCapital',
                type: 'custom',
                width: 140,
                rule: [
                    { required: false, message: '注册金额不能为空', trigger: ['change', 'blur'] },
                ],
                opsUnlockType: 'input',
            },

            {
                label: '企业性质',
                prop: 'ebcuPlatformNature',
                value: 'ebcuPlatformNature',
                type: 'custom',
                optionsKey: 'SYS_SUPPLIER_NATURE',
                rule: [
                    { required: true, message: '企业性质不能为空', trigger: ['change', 'blur'] },
                ],
                opsUnlockType: 'select',
            },

            // {
            //     label: '国家',
            //     prop: 'ebcuEbplCountryCode',
            //     value: 'ebcuEbplCountryCode',
            //     type: 'custom',
            //     options: {},
            //     rule: [
            //         { required: true, message: '国家不能为空', trigger: 'change' }
            //     ],
            //     opsUnlockType: 'input',
            // },
            {
                label: '国家(地区)省市区',
                prop: 'addressCode',
                value: 'addressCode',
                type: 'custom',
                span: 12,
                rule: [
                    { required: true, message: '国家(地区)/省/市/区(县)不能为空', trigger: 'change' }
                ],
                props: {
                    lazy: true,
                    checkStrictly: true,
                    lazyLoad(node, resolve) {
                        const { level, children } = node;
                        const params = {
                            level,
                            pageSize: 1000,
                            pageNo: 1,
                            countryCode: _.nth(node.pathNodes, 0)?.value || null
                        };

                        if (level === 0) {
                            params.parentCode = null;
                        } else {
                            params.parentCode = node.value;
                        }
                        queryAddressPlace(params).then(res => {
                            const nodes = res.data.list.map(item => {
                                return optionsFormat(item, node.level >= 4)
                            });
                            if (level !== 0 && children) {
                                node.children = [];
                            }
                            resolve(nodes);
                        });
                    }
                },
                opsUnlockType: 'custom',
            },
            // {
            //     label: '省',
            //     prop: 'ebcuEbplProvinceCode',
            //     value: 'ebcuEbplProvinceCode',
            //     type: 'custom',
            //     rule: [
            //         { required: true, message: '省不能为空', trigger: 'change' }
            //     ],
            // },
            // {
            //     label: '市',
            //     prop: 'ebcuEbplCityCode',
            //     value: 'ebcuEbplCityCode',
            //     type: 'custom',
            //     rule: [
            //         { required: true, message: '市不能为空', trigger: 'change' }
            //     ],
            // },
            // {
            //     label: '县区',
            //     prop: 'ebcuDistricts',
            //     value: 'ebcuDistricts',
            //     type: 'custom',
            //     rule: [
            //         { required: true, message: '县区不能为空', trigger: 'change' }
            //     ],
            // },
            // {
            //     label: '乡镇/街道',
            //     prop: 'ebcuTowns',
            //     value: 'ebcuTowns',
            //     type: 'custom',
            //     rule: [
            //         { required: false, message: '乡镇/街道不能为空', trigger: 'change' }
            //     ],
            //     opsUnlockType: 'input',
            // },
            {
                label: '地址',
                prop: 'ebcuAddress',
                value: 'ebcuAddress',
                type: 'input',
                span: 12,
                rule: [
                    { required: false, message: '地址不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '成立日期',
                prop: 'ebcuRegistrationDate',
                value: 'ebcuRegistrationDate',
                type: 'custom',
                rule: [
                    { required: false, message: '成立日期不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '经营状态',
                prop: 'regStatus',
                value: 'regStatus',
                type: 'custom',
                rule: [
                    { required: false, message: '经营状态不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '经营范围',
                prop: 'businessScope',
                value: 'businessScope',
                type: 'custom',
                span: 24,
                rule: [
                    { required: false, message: '经营范围不能为空', trigger: ['change'] }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '天眼参考行业',
                prop: 'tycIndustry',
                value: 'tycIndustry',
                type: 'custom',
                rule: [
                    { required: false, message: '天眼参考行业不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '人员规模',
                prop: 'staffNumRange',
                value: 'staffNumRange',
                type: 'custom',
                rule: [
                    { required: false, message: '人员规模不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '参保人数',
                prop: 'socialStaffNum',
                value: 'socialStaffNum',
                type: 'custom',
                rule: [
                    { required: false, message: '参保人数不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '实收注册资本',
                prop: 'actualCapital',
                value: 'actualCapital',
                type: 'custom',
                rule: [
                    { required: false, message: '实收注册资本不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '是否微小企业',
                prop: 'isMicroEnt',
                value: 'isMicroEnt',
                type: 'custom',
                optionsKey: 'SYS_YES_NO',
                rule: [
                    { required: false, message: '是否微小企业不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },

            {
                label: '智汇签验真',
                prop: 'isCertification',
                value: 'isCertification',
                type: 'custom',
                optionsKey: 'SYS_IS_CERTIFICATION',
                rule: [
                    { required: false, message: '智汇签验真不能为空', trigger: ['change'] }
                ],
                opsUnlockType: 'select',
            },

        ]
    },
    {
        title: '财务信息',
        ref: 'financeForm',
        formName: 'financeInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '是否关联交易',
                prop: 'isRelatedTransaction',
                value: 'isRelatedTransaction',
                type: 'custom',
                optionsKey: 'SYS_YES_NO',
                rule: [
                    { required: false, message: '是否关联交易不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            // {
            //     label: '内部OU组织',
            //     prop: 'ouOrganization',
            //     value: 'ouOrganization',
            //     type: 'custom',
            //     visible: true,
            //     rule: [
            //         { required: false, message: '内部OU组织不能为空', trigger: 'change' }
            //     ],
            //     opsUnlockType: 'input',
            // },
            {
                label: '内部OU组织',
                prop: 'ouOrganizationName',
                value: 'ouOrganizationName',
                name: '内部OU组织',
                type: 'advance',
                visible: true,
                rule: [
                    { required: true, message: '内部OU组织不能为空', trigger: ['change', 'blur'] }
                ],
                advanceConfig: [
                    { 'prop': 'operatingUnitName', 'value': '会计主体名称' },
                    { 'prop': 'operatingUnitId', 'value': '会计主体编码' }
                ],
                tableConfig: [
                    { 'prop': 'operatingUnitId', 'value': '会计主体编码' },
                    { 'prop': 'operatingUnitName', 'value': '会计主体名称' }
                ],
                prefix: '/api-lcrm',
                // method: 'post',
                advanceUrl: `/mdmService/efOrganRelations`,
                cbParams: ['operatingUnitId#ouOrganization', 'operatingUnitName#ouOrganizationName'], // legalSysId: 会计主体id
                beforeRequest: (params) => {
                    params.enabledFlag = accountEntityEnabled; // 启用状态
                    if (params.operatingUnitName) {
                        return params;
                    }
                    const inputKey = params.operatingUnitId?.trim();
                    const reg = new RegExp(/^-?\d+$/); // 数字正则
                    if (!reg.test(inputKey)) {
                        params.operatingUnitName = inputKey;
                        params.operatingUnitId = null;
                    } else {
                        params.operatingUnitId = inputKey;
                        params.operatingUnitName = null;
                    }
                    return params;
                },
                afterResponse: (res) => {
                    if (res && res.data && Array.isArray(res.data.list)) {
                        res.data.list = res.data.list.filter(item => !_.isNil(item))
                    }
                    return _.cloneDeep(res);
                },
                opsUnlockType: 'advance',
            },
            {
                label: '是否POS机收款',
                prop: 'receiveByPos',
                value: 'receiveByPos',
                type: 'custom',
                visible: true,
                optionsKey: 'SYS_YES_NO',
                rule: [
                    { required: true, message: '是否POS机收款不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
        ]
    },
    {
        title: '其他信息',
        ref: 'otherForm',
        formName: 'otherInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '销售产品',
                prop: 'mainProducts',
                value: 'mainProducts',
                type: 'input',
                rule: [
                    { required: true, message: '销售产品不能为空', trigger: 'change' }
                ]
            },
            {
                label: '公司简介',
                prop: 'companyProfile',
                value: 'companyProfile',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '公司简介不能为空', trigger: 'change' }
                ]
            },
            {
                label: 'AI简介（试行）',
                prop: 'introduction',
                value: 'introduction',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: 'AI简介（试行）不能为空', trigger: 'change' }
                ]
            },
            {
                label: '企业文化',
                prop: 'corporateCulture',
                value: 'corporateCulture',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '企业文化不能为空', trigger: 'blur' }
                ]
            },
            {
                label: '公司网址',
                prop: 'companyUrl',
                value: 'companyUrl',
                type: 'input',
                visible: true,
                rule: [
                    {
                        pattern: urlReg,
                        message: '公司网址格式不对',
                        trigger: 'blur'
                    },
                    { required: false, message: '公司网址不能为空', trigger: 'blur' },

                ]
            },
            {
                label: '电话',
                prop: 'ebcuTel',
                value: 'ebcuTel',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '电话不能为空', trigger: 'blur' },
                    {
                        pattern: telephoneReg,
                        message: '电话格式不对,只允许输入数字、()、-',
                        trigger: 'blur'
                    }
                ]
            },
            {
                label: '传真',
                prop: 'ebcuFax',
                value: 'ebcuFax',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '传真不能为空', trigger: 'blur' }
                ]
            },
            {
                label: '电子邮箱',
                prop: 'ebcuEmail',
                value: 'ebcuEmail',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '电子邮箱不能为空', trigger: 'blur' },
                    {
                        pattern: email,
                        message: '电子邮箱格式不对',
                        trigger: 'blur'
                    }
                ]
            },
            {
                label: '邮编',
                prop: 'ebcuZipCode',
                value: 'ebcuZipCode',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '邮编不能为空', trigger: 'blur' },
                    {
                        pattern: ebcuZipCOde,
                        message: '邮编格式不对',
                        trigger: 'blur'
                    }
                ]
            },
            {
                label: '备注',
                prop: 'ebcuRemark',
                value: 'ebcuRemark',
                type: 'input',
                sourceType: 'input',
                inputType: 'textarea',
                rows: 3,
                visible: true,
                span: 18,
                rule: [
                    { required: false, message: '备注不能为空', trigger: 'change' }
                ]
            },

        ]
    },
    {
        title: '系统信息',
        ref: 'systemForm',
        formName: 'systemInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '审批状态',
                prop: 'approvalStatus',
                value: 'approvalStatus',
                optionsKey: 'SYS_CUST_APPROVAL_STATUS',
                type: 'custom',
                rule: [
                    { required: false, message: '审批状态不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '来源系统',
                prop: 'sysSource',
                value: 'sysSource',
                type: 'custom',
                optionsKey: 'LCRM_CUSTOMER_SOURCE_SYS',
                visible: true,
                rule: [
                    { required: false, message: '来源系统不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '内外部客户',
                prop: 'isGroupCustomer',
                value: 'isGroupCustomer',
                optionsKey: 'INSIDE_OUTER_CLIENT',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '内外部客户不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '是否销售公司',
                prop: 'isSaleCompany',
                value: 'isSaleCompany',
                optionsKey: 'SYS_YES_NO',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '是否销售公司不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '是否代理商',
                prop: 'isAgent',
                value: 'isAgent',
                optionsKey: 'SYS_YES_NO',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '是否代理商不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '是否分销商',
                prop: 'isDistributor',
                value: 'isDistributor',
                optionsKey: 'SYS_YES_NO',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '是否分销商不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'select',
            },
            {
                label: '客户销售易id',
                prop: 'crmCustomerId',
                value: 'crmCustomerId',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '客户销售易id不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '创建时间',
                prop: 'createTime',
                value: 'createTime',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '创建时间不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '创建用户',
                prop: 'createUserCode',
                value: 'createUserCode',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '创建用户不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '创建用户名称',
                prop: 'createUserName',
                value: 'createUserName',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '创建用户名称不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '更新时间',
                prop: 'updateTime',
                value: 'updateTime',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '更新时间不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '修改用户',
                prop: 'updateUserCode',
                value: 'updateUserCode',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '修改用户不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },
            {
                label: '修改用户名称',
                prop: 'updateUserName',
                value: 'updateUserName',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '修改用户名称不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'input',
            },

        ]
    },
];

